export const DEFAULT_MAX_RETRIES = 10;
export const INITIAL_RECONNECT_DELAY = 5000;
export const MAX_RECONNECT_DELAY = 60000;
export const RECONNECT_JITTER = 1000;

// Типы эвентов которые мы обрабатываем и хотим слушать нашим ссе-клиентом
// EVENT_NOTIFICATION - все события изз нашей апи/реббита
// WEBHOOK_NOTIFICATION - события сторонних систем которые были запущены по вебхуку
export const EVENT_TYPES = {
  EVENT_NOTIFICATION: 'EVENT_NOTIFICATION',
  WEBHOOK_NOTIFICATION: 'WEBHOOK_NOTIFICATION',
} as const;
